import { CHANGE_TABLE_DATE_RANGE } from "./types";

export const changeTableDateRange = dateRange => async (dispatch, getState) => {
  await dispatch({
    type: CHANGE_TABLE_DATE_RANGE,
    payload: dateRange
  });
};



// WEBPACK FOOTER //
// ./src/actions/changeTableDateRange.js